export default function Hero() {
  const scrollToRegistration = () => {
    const element = document.getElementById('registration');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="hero" className="relative min-h-screen flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="/hero-bg.jpg"
          alt="ملتقى الشباب"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/75 via-black/65 to-black/75"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 pt-28 pb-20 md:py-32 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 md:gap-16 items-center">
          <div className="text-white space-y-4 md:space-y-8">

            <div className="flex items-center gap-3 md:gap-4">
              <div className="w-10 h-10 md:w-12 md:h-12 bg-white/10 backdrop-blur-sm rounded-lg flex items-center justify-center shrink-0">
                <i className="ri-government-line text-xl md:text-2xl text-[#D4AF37]"></i>
              </div>
              <div className="text-xs md:text-sm font-medium text-[#D4AF37]">تحت رعاية إمارة <span className="blur-sm select-none">منطقة المدينة المنورة</span></div>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-7xl font-bold leading-tight">
              ملتقى احتياجات الشباب
              <span className="block text-3xl md:text-4xl lg:text-5xl mt-2 md:mt-4 text-[#D4AF37]">المدينة المنورة 2026</span>
            </h1>

            <p className="text-base md:text-xl leading-relaxed text-white/90 max-w-2xl">
              ملتقى وطني سنوي يهدف إلى تشخيص وتحليل احتياجات الشباب في المملكة من خلال أوراق عمل علمية وورش تطبيقية وحلقات نقاش، للخروج بتوصيات عملية تدعم صناعة القرار الشبابي
            </p>

            <div className="flex flex-col sm:flex-row items-stretch sm:items-center gap-3 md:gap-4 pt-2 md:pt-4">
              <button
                onClick={scrollToRegistration}
                className="px-6 md:px-8 py-3 md:py-4 bg-[#1B5E20] text-white rounded-full font-bold text-base md:text-lg hover:bg-[#2E7D32] transition-all duration-300 flex items-center justify-center gap-2 md:gap-3 whitespace-nowrap cursor-pointer shadow-lg hover:shadow-xl"
              >
                سجل الآن
                <i className="ri-arrow-left-line text-lg md:text-xl"></i>
              </button>
              <button className="px-6 md:px-8 py-3 md:py-4 border-2 border-white text-white rounded-full font-bold text-base md:text-lg hover:bg-white hover:text-[#1B5E20] transition-all duration-300 flex items-center justify-center gap-2 md:gap-3 whitespace-nowrap cursor-pointer">
                تحميل البروشور
                <i className="ri-download-line text-lg md:text-xl"></i>
              </button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4 pt-4 md:pt-8">
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 md:p-6 border border-white/20">
                <div className="flex items-center gap-2 md:gap-3 mb-2">
                  <i className="ri-calendar-line text-xl md:text-2xl text-[#D4AF37]"></i>
                  <span className="text-xs md:text-sm text-white/70">التاريخ</span>
                </div>
                <div className="text-base md:text-lg font-bold">15-16 رجب 1447هـ</div>
                <div className="text-xs md:text-sm text-white/60 mt-1">13-14 يناير 2026م</div>
              </div>
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 md:p-6 border border-white/20">
                <div className="flex items-center gap-2 md:gap-3 mb-2">
                  <i className="ri-time-line text-xl md:text-2xl text-[#D4AF37]"></i>
                  <span className="text-xs md:text-sm text-white/70">المدة</span>
                </div>
                <div className="text-base md:text-lg font-bold">يومان كاملان</div>
              </div>
              <div className="bg-white/10 backdrop-blur-md rounded-2xl p-4 md:p-6 border border-white/20">
                <div className="flex items-center gap-2 md:gap-3 mb-2">
                  <i className="ri-map-pin-line text-xl md:text-2xl text-[#D4AF37]"></i>
                  <span className="text-xs md:text-sm text-white/70">المكان</span>
                </div>
                <div className="text-base md:text-lg font-bold">المدينة المنورة</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 right-1/2 transform translate-x-1/2 animate-bounce hidden md:block">
        <i className="ri-arrow-down-line text-4xl text-white/70"></i>
      </div>
    </section>
  );
}
